import { gql } from '@apollo/client';
import { FieldFragment } from 'graphql/Field/fragments/FieldFragment';
import { MediaFragment } from 'graphql/Media/fragments/MediaFragment';
/**
 * @fragment SaleItemVariantValueFragment
 * @since 1.0.0
 */
export const SaleItemVariantValueFragment = gql `
  fragment SaleItemVariantValueFragment on SaleItemVariantValue {
    id
    value
    field {
      ...FieldFragment
    }
  }

  ${FieldFragment}
`;
/**
 * @fragment DealItemSaleItemVariantFragment
 * @since 1.0.0
 */
export const DealItemSaleItemVariantFragment = gql `
  fragment DealItemSaleItemVariantFragment on SaleItemVariant {
    id
    sku
    price
    cost
    inventory
    active
    deletedAt

    image {
      ...MediaFragment
    }

    values {
      ...SaleItemVariantValueFragment
    }

    options {
      id
      price
      required
      included
      locked
      recommended
      item {
        id
        title
        infos
        sku
        price
        active
        deletedAt

        group {
          id
          title
          hasUniqueOptionRestriction
          mustHaveOptionSelected
        }

        groups {
          id
          title
          display
          hasUniqueOptionRestriction
          mustHaveOptionSelected
        }
      }
      relations {
        id
        type
        quantity
        relatedSaleItem {
          id
          title
          price
          sku
        }
      }
    }

    fieldValues {
      id
      value
      field {
        id
        name
        title
        infos
        visibility
        promote
        type
        group {
          id
          category
        }
      }
    }
  }

  ${SaleItemVariantValueFragment}
  ${MediaFragment}
`;
